import React, {useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {cartItemInterface} from "../cartItemInterface";
import CartItemQuantity from "./cartItemQuantity";
import CartItemTotal from "./cartItemTotal";
import CartItemSearch from "./cartItemSearch";
import CartItemSearchButton from "./cartItemSearchButton";
import NoteEditor from "../noteEditor";
import AdvancedQuotingListItemRemoveButton from "./advancedQuotingListItemRemoveButton";
import {setNewActiveQuote} from "../../../misc/quotesFunctions";
import {setActiveQuoteIndex} from "../../../actions/roomsFunctions";
import {checkIfNeedToSetNewCategory} from "../../../misc/categorySwitchingFunctions";
import {SQFT_FEATURES} from "../../sqft/constants";
import {wizardAllObjectInterface, wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {IS_OFFLINE_MODE} from "../../../config";
import ShoppingCartItemsBundledProducts from "../shoppingCartItemsBundledProducts";

const AdvancedQuotingListItem = (props) => {

  let {cartItem, subPart, deleteEmptyCartItem, quoteIndex, activeQuoteIndex, setActiveQuoteIndex, isBundleChild,
    qtCategoryName, stepIndex, wizardGroup, wizardAllObject, cartItems, stepDisabled} = props;

  const [quantity, setQuantity] = useState("");
  const [editorVisible, setEditorVisible] = useState("");

  const handleNoteButtonClick = () => {
    const newVisible = !editorVisible;
    setEditorVisible(newVisible);
    setTimeout(() => {
      newVisible
        ? window.addEventListener('click', handleWrapperBlur)
        : window.removeEventListener('click', handleWrapperBlur)
    }, 0)
  };

  const onNoteSave = () => {
    handleNoteButtonClick();
  };

  const handleWrapperBlur = (event) => {
    const disallowClasses = [".product-note", ".aq-button--note"];
    if (editorVisible && !disallowClasses.some(cls => event.target.closest(cls))) {
      setEditorVisible(false);
    }
  };

  const setClickedItemActiveQuoteIndex = async () => {
    if (quoteIndex !== activeQuoteIndex) {
      await setNewActiveQuote(quoteIndex);
      setActiveQuoteIndex(quoteIndex);
      checkIfNeedToSetNewCategory(quoteIndex);
    }
    return Promise.resolve()
  };


  const isSearchDisabled = cartItem.partId === SQFT_FEATURES.slabs || isBundleChild || stepDisabled;
  const hasBundleProducts = cartItems.some(cItem => cItem.bundleParentId === cartItem.id);

  return (
    <div className={"aq" + (stepDisabled ? " disabled2" : "")}>
      <div className="aq-item">
        <AdvancedQuotingListItemRemoveButton cartItem={cartItem}
                                             deleteEmptyCartItem={deleteEmptyCartItem}
                                             isDisabled={stepDisabled}
                                             quoteIndex={quoteIndex}/>
        <div className="aq-cell aq-cell--name">
          <div className="aq-title"><FormattedMessage id="advancedQuoting.itemTitle"/></div>
          <div className="aq-main">
            <CartItemSearch cartItem={cartItem} subPart={subPart}
                            quantity={quantity}
                            quoteIndex={quoteIndex}
                            qtCategoryName={qtCategoryName}
                            stepIndex={stepIndex}
                            wizardGroup={wizardGroup}
                            wizardAllObject={wizardAllObject}
                            isDisabled={isBundleChild || stepDisabled}
            />
            {isSearchDisabled || IS_OFFLINE_MODE
              ? null
              : <CartItemSearchButton cartItem={cartItem}
                                      subPart={subPart}
                                      quoteIndex={quoteIndex}
                                      setClickedItemActiveQuoteIndex={setClickedItemActiveQuoteIndex}
                                      qtCategoryName={qtCategoryName}
                                      wizardAllObject={wizardAllObject}
                                      stepIndex={stepIndex}/>}
            <button className={"aq-button aq-button--note"
            + (cartItem.isEmpty || cartItem.isMinimumCharge ? " aq-button--disabled" : "")}
                    disabled={cartItem.isEmpty || cartItem.isMinimumCharge} onClick={handleNoteButtonClick}/>
          </div>
        </div>
        <CartItemQuantity cartItem={cartItem}
                          subPart={subPart}
                          setParentQuantity={setQuantity}
                          isDisabled={isBundleChild || stepDisabled}
                          setClickedItemActiveQuoteIndex={setClickedItemActiveQuoteIndex}/>
        <CartItemTotal cartItem={cartItem} quantity={cartItem.quantity}/>
      </div>
      {cartItem.isEmpty || cartItem.isMinimumCharge ? null : (<div className="aq-item">
        <div className="aq-cell aq-cell--remove"/>
        <div className="aq-cell aq-cell--name">
          <NoteEditor cartItem={cartItem}
                      dbFeatureId={cartItem.cartFeature.dbFeature.id}
                      editorVisible={editorVisible}
                      closeEditor={onNoteSave}/>
        </div>
        <div className="aq-cell aq-cell--total"/>
      </div>)}
      {hasBundleProducts ? <ShoppingCartItemsBundledProducts parentCartItem={cartItem}
                                                             isAdvancedMode={true}
                                                             advancedModeProperties={{
                                                               subPart,
                                                               quoteIndex,
                                                               qtCategoryName,
                                                               stepIndex,
                                                               wizardGroup,
                                                               wizardAllObject,
                                                               deleteEmptyCartItem,
                                                             }}
                                                             editFeatureGroupClick={() => null}/> : null}
    </div>
  )
};

AdvancedQuotingListItem.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  subPart: PropTypes.object.isRequired,
  deleteEmptyCartItem: PropTypes.func.isRequired,
  quoteIndex: PropTypes.number.isRequired,
  qtCategoryName: PropTypes.string,
  //wizard
  wizardAllObject: PropTypes.shape(wizardAllObjectInterface),
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  stepIndex: PropTypes.number,
  isBundleChild: PropTypes.bool,
  stepDisabled: PropTypes.bool,
};

const mapStateToProps = (store) => {
  const {activeQuoteIndex} = store.quotesState;
  const {cartItems} = store.cartState;
  return {
    activeQuoteIndex,
    cartItems,
  };
};

const mapDispatchToProps = {
  setActiveQuoteIndex,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedQuotingListItem)

